module.exports = __webpack_public_path__ + "img/carbs-img-2.f1e5e375.png";